import { create } from "zustand";
import { AUTH_SOURCE } from "../../constants/authSource";
import {
  resolveCreOrganisationId,
  writeStoredCreOrganisationId,
  isCreOrganisationIdValid,
} from "../../cre/creOrganisation";
import { API_BASE_URLS } from "../../config/apiBaseUrlsConstants";

export const useGlobalStore = create((set, get) => ({
  isInitialized: false,
  accessToken: null,
  _tokenBridgeInitialized: false,
  radicalUser: null,
  authSource: null,
  creUser: null,
  creSelectedOrganisationId: null,

  clear: () => {
    set({
      isInitialized: false,
      accessToken: null,
      radicalUser: null,
      authSource: null,
      creUser: null,
      creSelectedOrganisationId: null,
    });
  },

  setCreSelectedOrganisation: (organisationId) => {
    const { creUser } = get();
    if (!isCreOrganisationIdValid(creUser, organisationId)) return;
    if (creUser?.userId) {
      writeStoredCreOrganisationId(creUser.userId, organisationId);
    }
    set({ creSelectedOrganisationId: organisationId });
  },

  initializeWithRadicalToken: (token) => {
    if (!token || typeof token !== "string") return false;
    set({
      accessToken: token.trim(),
      authSource: AUTH_SOURCE.RADICAL,
      isInitialized: true,
      radicalUser: null,
      creUser: null,
      creSelectedOrganisationId: null,
    });
    return true;
  },

  initializeWithCreToken: async (token) => {
    try {
      const response = await fetch(
        `${API_BASE_URLS.reportingCre}/api/TokenValidation/Validate`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (!response.ok) {
        return false;
      }
      const data = await response.json();
      if (data.success && data.user) {
        const creUser = data.user;
        const creSelectedOrganisationId = resolveCreOrganisationId(creUser);
        if (creUser.userId && creSelectedOrganisationId) {
          writeStoredCreOrganisationId(
            creUser.userId,
            creSelectedOrganisationId,
          );
        }
        set({
          accessToken: token,
          creUser,
          creSelectedOrganisationId,
          authSource: AUTH_SOURCE.CRE,
          isInitialized: true,
          radicalUser: null,
        });
        return true;
      }
    } catch (error) {
      console.error("CRE token validation failed:", error);
    }
    return false;
  },

  setRadicalUser: (payload) => {
    set({ radicalUser: payload ?? null });
  },

  getAccessToken: async () => {
    const { accessToken } = get();

    if (accessToken) {
      return accessToken;
    }

    throw new Error("No access token available");
  },
}));
